import React, { Component } from "react";
import { CalendarCheck, FolderOpen, Gauge, KeyRound, LogOut, RefreshCw, Shield, User } from "lucide-react";
import { clearAuth, getCurrentUser, getRefreshToken } from "../../utill/auth";
import { revokeRefreshTokenApi } from "../../utill/api/loginApi";
import { toUserError } from "../../utill/toUserError";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { NavLink, Link, Navigate } from 'react-router-dom';
import './Header.scss';
import logo from '../../assets/img/logo.svg';
import { permissionModules } from "../../utill/config";
import ChangePasswordModal from "./ChangePasswordModal";
import ToastAlert from "../../shared/notificationAlert/toastAlert";

const getInitials = (name) => {
  if (!name) return "U";
  const parts = name.trim().split(/\s+/);
  return parts.slice(0, 2).map(p => p[0] || "").join("").toUpperCase() || "U";
};

class Header extends Component {
  currentUser = getCurrentUser();

  constructor() {
    super();
    this.state = {
      error: null,
      loggedIn: true,
      showModal: false,
      syncDefaultUrl: ""
    };
  }

  componentDidMount() {
    let currentUser = getCurrentUser();
    if (currentUser && currentUser.userType &&
      currentUser.userGroupId === 1 &&
      permissionModules[currentUser.userType].sync.includes("pdVehicleSync")
    ) {
      this.setState({ syncDefaultUrl: "/sync/pdvehicle" });
    } else if (currentUser && currentUser.userType &&
      currentUser.userGroupId === 1 &&
      permissionModules[currentUser.userType].sync.includes("ecuMasterSync")
    ) {
      this.setState({ syncDefaultUrl: "/sync/ecumaster" });
    } else if (currentUser && currentUser.userType &&
      currentUser.userGroupId === 2 &&
      permissionModules[currentUser.userType].sync.includes("iAlert")
    ) {
      this.setState({ syncDefaultUrl: "/sync/ialert" });
    } else {
      this.setState({ syncDefaultUrl: "/sync/hexsync" });
    }
  }

  logOut = (e) => {
    // Server-side revoke of the refresh token. Fire-and-forget — local state is
    // cleared regardless so the UX isn't blocked on the network.
    const refreshToken = getRefreshToken();
    if (refreshToken) {
      revokeRefreshTokenApi(refreshToken);
    }
    clearAuth();
    this.setState({ loggedIn: false })
  }

  toggleModal = () => {
    this.setState(oldState => ({
      showModal: !oldState.showModal
    }));
  }

  errorHandled = () => {
    this.setState({ error: null });
  };

  showModalSuccess = e => {
    this.setState({ error: toUserError(e) });
  };

  render() {
    if (!this.state.loggedIn) {
      return <Navigate to='/login' replace />
    }
    return (
      <>
        {/* Toast Alert */}
        {Boolean(this.state.error) ? (
          <ToastAlert
            show={Boolean(this.state.error)}
            onClose={this.errorHandled}
            error={this.state.error}
          />
        ) : null}
        <Navbar
          collapseOnSelect
          expand="sm"
          bg="light"
          variant="light"
          fixed="top"
        >
          <Navbar.Brand>
            <img
              src={logo}
              className="d-inline-block align-top"
              alt="Ashok Leyland"
            />
          </Navbar.Brand>
          <Navbar.Brand>
            <span className="main-head">ECU</span>&nbsp;
            <span className="sub-head">OTA</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="justify-content-end"
          >
            <Nav>
              <Nav.Item>
                <NavLink
                  className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                  to="/dashboard"
                >
                  <Gauge className="nav-link-icon" size={16} aria-hidden="true" />
                  <span className="nav-link-label">DASHBOARD</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                  to="/schedules"
                >
                  <CalendarCheck className="nav-link-icon" size={16} aria-hidden="true" />
                  <span className="nav-link-label">SCHEDULES</span>
                </NavLink>
              </Nav.Item>
              {this.currentUser &&
                this.currentUser.userType
                && permissionModules[this.currentUser.userType].file.includes("view") ? (
                  <Nav.Item>
                    <NavLink
                      className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                      to="/files"
                    >
                      <FolderOpen className="nav-link-icon" size={16} aria-hidden="true" />
                      <span className="nav-link-label">FILES</span>
                    </NavLink>
                  </Nav.Item>
                ) : null}
              {this.currentUser &&
                this.currentUser.userType &&
                permissionModules[this.currentUser.userType].admin.includes("view") ? (
                  <Nav.Item>
                    <NavLink
                      className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                      to="/admin"
                    >
                      <Shield className="nav-link-icon" size={16} aria-hidden="true" />
                      <span className="nav-link-label">ADMIN</span>
                    </NavLink>
                  </Nav.Item>
                ) : null}
              {this.currentUser &&
                this.currentUser.userType &&
                (this.currentUser.userGroupId === 1 || this.currentUser.userGroupId === 2) &&
                permissionModules[this.currentUser.userType].sync.includes("view") ? (
                  <Nav.Item>
                    <NavLink
                      className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                      to="/sync"
                    >
                      <RefreshCw className="nav-link-icon" size={16} aria-hidden="true" />
                      <span className="nav-link-label">SYNC</span>
                    </NavLink>
                  </Nav.Item>
                ) : null}
              <NavDropdown
                title={
                  <span className="user-pill-trigger">
                    <span className="user-pill-avatar" aria-hidden="true">
                      {getInitials(this.currentUser && this.currentUser.name)}
                    </span>
                    <span className="user-pill-name">
                      {this.currentUser && this.currentUser.name ? this.currentUser.name : 'User'}
                    </span>
                  </span>
                }
                align="end"
                className="user-pill"
                id="dropdown-user-align-right"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  <User className="me-2 text-muted" size={16} aria-hidden="true" />
                  My Profile
                </NavDropdown.Item>
                <NavDropdown.Item onClick={this.toggleModal}>
                  <KeyRound className="me-2 text-muted" size={16} aria-hidden="true" />
                  Change Password
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/logout" onClick={this.logOut} className="user-pill-signout">
                  <LogOut className="me-2" size={16} aria-hidden="true" />
                  Sign out
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <ChangePasswordModal
          show={this.state.showModal}
          onHide={this.toggleModal}
        />
      </>
    );
  }
}

export default Header;
